/**
 * Additional compliance documents server may request from a person during
 * KYC (proof of address, BVN-related images, etc.). Wire values match the
 * server contract verbatim.
 */
export var AfriexComplianceDocumentTypes;
(function (AfriexComplianceDocumentTypes) {
    AfriexComplianceDocumentTypes["ID"] = "id";
    AfriexComplianceDocumentTypes["ProofOfAddress"] = "proof_of_address";
    AfriexComplianceDocumentTypes["Selfie"] = "selfie";
    AfriexComplianceDocumentTypes["CardDetails"] = "card_details";
    AfriexComplianceDocumentTypes["ProofOfSourceOfIncome"] = "proof_of_source_of_income";
    AfriexComplianceDocumentTypes["BankStatement"] = "bank_statement";
    AfriexComplianceDocumentTypes["BVN"] = "BVN";
    AfriexComplianceDocumentTypes["DateOfBirth"] = "DOB";
    AfriexComplianceDocumentTypes["BVNBiometric"] = "BVN_BIOMETRIC";
    AfriexComplianceDocumentTypes["BVNSelfie"] = "BVN_SELFIE";
    AfriexComplianceDocumentTypes["BVNLivenessImages"] = "BVN_LIVENESS_IMAGES";
})(AfriexComplianceDocumentTypes || (AfriexComplianceDocumentTypes = {}));
//# sourceMappingURL=AfriexComplianceDocumentTypes.js.map